import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CSSRulePlugin } from "gsap/CSSRulePlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CSSRulePlugin);

import Swiper from 'swiper/bundle';

// Effetto Parallasse
document.querySelectorAll("[data-speed]").forEach(el => {

    let parallaxTl = gsap.timeline( {
        scrollTrigger: {
            trigger: el,
            start: "top bottom",
            end: "bottom top",
            invalidateOnRefresh: true,
            scrub: true,
        }
    })
    .fromTo(el, {y: 100}, {y: (1 - parseFloat(el.getAttribute("data-speed"))) * ScrollTrigger.maxScroll(window) * 0.5, ease: "none"});

});

document.querySelectorAll(".decorazione").forEach(el => {
    let decorazioneScale = gsap.timeline( {
        scrollTrigger: {
            trigger: el,
            start: "top bottom",
            end: "bottom top",
            invalidateOnRefresh: true,
            scrub: true,
        }
    })
    .fromTo(el, {scale: 0.8}, {scale: 1});
});


let backdropArray = gsap.utils.toArray("[backdrop]");
backdropArray.forEach(el => {
    let backdropTl = gsap.timeline({
        scrollTrigger: {
            trigger: el,
            start: "top bottom",
            end: "bottom top",
            invalidateOnRefresh: true,
            scrub: true,
            onUpdate: self => {
                self.trigger.style.setProperty('--backdropPosition', self.progress * 100 + "px");
            }
        }
    });
});

let backdropSecondaryArray = gsap.utils.toArray("[backdrop-secondary]");
backdropSecondaryArray.forEach(el => {
    let backdropSecondaryTl = gsap.timeline({
        scrollTrigger: {
            trigger: el,
            start: "top bottom",
            end: "bottom top",
            invalidateOnRefresh: true,
            scrub: true,
            onUpdate: self => {
                self.trigger.style.setProperty('--backdropPosition', self.progress * 100 + "px");
            }
        }
    });
});

if (document.querySelector('.slider-home')) {
    var swiperHome = new Swiper('.slider-home', {
        slidesPerView: 1,
        autoplay: {
            delay: 5000,
        },
        speed: 1000,
        loop: true,
        enabled: false,
    });
}

document.addEventListener("DOMContentLoaded", function (event) {

    let bg = document.querySelector('.hero');
    if (document.querySelector('.slider-home')) { 
        bg = document.querySelector(".swiper-slide");
    }

    let bgImg = bg.style.backgroundImage;

    if (!bgImg) {
        
        let heroTextArray = gsap.utils.toArray([`.hero h1`, `.hero p`, `.hero h2`, `.hero h3`, `.hero h4`, `.hero h5`, `.hero h6`, , `.hero button`]);
        
        gsap.to(`.hero`, {opacity: 1, duration: .5});
        gsap.fromTo(heroTextArray, {opacity: 0, y:-20 }, {opacity: 1, duration: .5, y: 0, stagger: .4, delay: .5});

        return;
    }
    
    let image = new Image();
    image.src = bgImg.slice(5, -2);
    image.onload = function () {
        // Hero     
        let heroTextArray = gsap.utils.toArray([`.hero h1`, `.hero p`, `.hero h2`, `.hero h3`, `.hero h4`, `.hero h5`, `.hero h6`, , `.hero button`]);
        
        gsap.to(`.hero`, {opacity: 1, duration: .5});
        gsap.fromTo(heroTextArray, {opacity: 0, y:-20 }, {opacity: 1, duration: .5, y: 0, stagger: .4, delay: .5});

        if (swiperHome) {
            swiperHome.enable();
        }

    }
});

// Hero 



// Slider Cursor

// let slider = document.querySelector(".slider-w-cursor");

// if (slider) {

//     const cursor = document.querySelector(".slider-cursor");
//     const cursorLink = document.querySelectorAll(".slider-w-cursor a");

//     gsap.set(".slider-cursor", {xPercent: -50, yPercent: -50});

//     let xTo = gsap.quickTo(".slider-cursor", "x", {duration: 0.3, ease: "power3"}),
//         yTo = gsap.quickTo(".slider-cursor", "y", {duration: 0.3, ease: "power3"});

//     window.addEventListener("mousemove", e => {
//         xTo(e.clientX);
//         yTo(e.clientY);
//     });

//     slider.addEventListener("mouseover", e => {
//         cursor.classList.add("visible");
//     });

//     slider.addEventListener("mouseout", e => {
//         cursor.classList.remove("visible");
//     });

//     cursorLink.forEach(link => {
//         link.addEventListener("mouseover", e => {
//             cursor.classList.add("focus");
//         });

//         link.addEventListener("mouseout", e => {
//             cursor.classList.remove("focus");
//         });
//     });
// }


